import { TableBody, TableRow, TableCell, Badge } from '@mui/material'
import { useMemo } from 'react'
import { ChangeState, Color, DicomTagsTableBodyProps } from '@features/subject/subject.types'
import { getComparatorDicom } from '@features/subject/utils'
import { legendItems } from './DicomTagsDialog'

export default function DiacomTagsTableBodyView({ rows, order, orderBy }: DicomTagsTableBodyProps) {
  const visibleRows = useMemo(() => [...rows].sort(getComparatorDicom(order, orderBy)), [order, orderBy, rows])

  const getColorByStatus = (status: ChangeState): Color => {
    const legendItem = legendItems.find((item) => {
      return item.status.toLowerCase() === status.toLowerCase()
    })
    return legendItem?.color || 'default'
  }

  return (
    <TableBody data-testid="table-body">
      {visibleRows.map((row, i) => (
        <TableRow
          key={`${row.id}_${i}`}
          sx={{
            borderBottom: '1px solid rgba(220, 227, 229, 1)',
            cursor: 'pointer',
          }}
          hover
          data-testid="table-row"
        >
          <TableCell align="center" data-testid="cell-status" sx={{ p: 0.65 }}>
            <Badge variant="dot" color={getColorByStatus(row.status)} />
          </TableCell>
          <TableCell align="left" data-testid="cell-tag" sx={{ p: 0.65 }}>
            {row.tag} {row.tagName}
          </TableCell>
          <TableCell align="left" data-testid="cell-originalValue" sx={{ p: 0.65 }}>
            {row.originalValue}
          </TableCell>
          <TableCell align="left" data-testid="cell-newValue" sx={{ p: 0.65 }}>
            {row.newValue}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  )
}
